import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminComparador from "@/pages/admin/AdminComparador";

export const Route = createFileRoute("/admin/comparador")({
  head: () => seoHead({
    title: "Comparador | Administração Shopping do Bem",
    description: "Revisão dos produtos do comparador de preços.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminComparador />
    </AdminRoute>
  ),
});
